import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { PortfolioBalancer } from "../../components/portfolio-balancer/PortfolioBalancer";

export function PortfolioBalancerView() {
    return (
        <Accordion defaultExpanded>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon/>}
                sx={{
                    fontSize: "16px",
                    fontWeight: "700",
                    height: "0px",
                    backgroundColor: 'rgb(240,240,240)',
                    minHeight: 35,
                    '&.Mui-expanded': {
                        minHeight: 35,
                        backgroundColor: 'rgb(240,240,240)',
                        borderBottom: 1,
                        borderColor: 'rgb(200,200,200)',
                    },
                    paddingLeft: '10px',
                }}
            >
                Balancer (only for short current date and long expiration date balance profiles)
            </AccordionSummary>
            <AccordionDetails>
                <PortfolioBalancer />
            </AccordionDetails>
        </Accordion>
    );
}